import { render, staticRenderFns } from "./adminUsersTable.vue?vue&type=template&id=15796b68"
import script from "./adminUsersTable.vue?vue&type=script&lang=js"
export * from "./adminUsersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports